// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"CustomTooltip_childrenWrapper__vkLvv"};